import React from 'react';
import { SpeechToTextLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoToTextConfig } from '@/data/landingConfig/landingVideoToTextConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoToText } from './schemaObject';

interface Props {}
const VideoToText: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoToText} />
			<SpeechToTextLandingTemplate
				data={landingVideoToTextConfig}
				funnelLinkService={GenerateLandingLinkService.funnelSpeechToText()}
			/>
		</>
	);
};

export default VideoToText;
